import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMAGE, PRODUCT_NAME } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function ProductImage({
  className = ''
}: {
  className?: string;
}) {
  return <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} aria-label={`Comprar ${PRODUCT_NAME}`} className={`block rounded-2xl focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan-400/50 ${className}`} data-id="element-53" data-mp="2lkoj6oj7qniq">
      <img src={PRODUCT_IMAGE} alt={`${PRODUCT_NAME}: 4 volúmenes y 5 bonos`} className="h-auto w-full" data-id="element-54" data-mp="2bp4uam32gp3h" />
    </a>;
}